import { createTheme } from '@mui/material/styles'

export const UpsiderDefaultTheme = createTheme({
  breakpoints: {
    values: {
      [`4xl`]: 1536, // used in index page
      [`3xl`]: 1160, // used in detail page
      [`2xl`]: 1040, // used in dialog
      xl: 857,
      lg: 640,
      md: 480,
      sm: 360,
      xs: 0,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          boxShadow: 'none',
        },
      },
      variants: [
        {
          props: { severity: 'success' },
          style: {
            backgroundColor: '#f1ffe9',
            color: '#38980d',
          },
        },
        {
          props: { severity: 'error' },
          style: {
            backgroundColor: '#ffeff1',
            color: '#eb161b',
          },
        },
        {
          props: { severity: 'warning' },
          style: {
            backgroundColor: '#fff4ed',
            color: '#eb5e00',
          },
        },
        {
          props: { severity: 'info' },
          style: {
            backgroundColor: '#e9fdff',
            color: '#0c91eb',
          },
        },
      ],
    },
    MuiPaper: {
      styleOverrides: {
        elevation0: {
          boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.1)',
        },
        elevation2: {
          boxShadow:
            '0px 0px 1px rgba(0, 0, 0, 0.05), 0px 1px 2px rgba(0, 0, 0, 0.16)',
        },
        elevation4: {
          boxShadow:
            '0px 0px 1px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.16)',
        },
        elevation16: {
          boxShadow:
            '0px 1px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(0, 0, 0, 0.16)',
        },
        elevation24: {
          boxShadow:
            '0px 2px 8px rgba(0, 0, 0, 0.05), 0px 12px 24px rgba(0, 0, 0, 0.16)',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#616161',
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        elevation: 16,
      },
    },
    MuiPopover: {
      defaultProps: {
        elevation: 16,
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          title2: 'p',
          title1: 'p',
        },
      },
    },
    MuiChip: {
      variants: [
        {
          props: { color: 'default' },
          style: {
            backgroundColor: '#e0e0e0',
          },
        },
        {
          props: { color: 'success' },
          style: {
            backgroundColor: '#4ab51a',
          },
        },
        {
          props: { color: 'error' },
          style: {
            backgroundColor: '#f8464d',
          },
        },
        {
          props: { color: 'warning' },
          style: {
            backgroundColor: '#f87e2c',
          },
        },
      ],
    },
  },
  /**
   * The default palette is set to the color used by the U-Text component.
   * If you want other components to use a different color than this default setting,
   * override the default palette in the settings for that component in the components property.
   * @see https://mui.com/material-ui/customization/creating-themed-components/#2-create-the-component
   */
  palette: {
    action: {
      disabled: undefined,
      disabledBackground: undefined,
    },
    primary: {
      contrastText: '#ffffff',
      main: '#07a3b2',
    },
    primaryLight: {
      contrastText: '#ffffff',
      main: '--c-primary-70',
    },
    secondary: {
      contrastText: '#ffffff',
      main: '#212121',
    },
    success: {
      contrastText: '#ffffff',
      main: '#38980d',
    },
    error: {
      contrastText: '#ffffff',
      main: '#eb161b',
    },
    warning: {
      contrastText: '#ffffff',
      main: '#eb5e00',
    },
    info: {
      contrastText: '#ffffff',
      main: '#0c91eb',
    },
    white: {
      contrastText: '#212121',
      main: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#616161',
    },
  },
  typography: {
    fontFamily: [
      'Inter',
      'Noto Sans JP',
      '游ゴシック体',
      'YuGothic',
      '游ゴシック',
      'Yu Gothic',
      'ヒラギノ角ゴ ProN W3',
      'Hiragino Kaku Gothic ProN',
      'メイリオ',
      'Meiryo',
      'sans-serif',
    ].join(','),
    title1: {
      fontSize: 24,
    },
    title2: {
      fontSize: 20,
    },
    caption1: {
      fontSize: 13,
    },
    caption2: {
      fontSize: 12,
    },
  },
})
